// Firebase Auth error codes a sign-up can fail with, mapped to the
// register.errors.* keys in translations/{en,es}/common.json. Anything else
// gets the generic message.
const KEYS = {
  "auth/email-already-in-use": "emailInUse",
  "auth/invalid-email": "invalidEmail",
  "auth/weak-password": "weakPassword",
  "auth/operation-not-allowed": "notAllowed",
  "auth/too-many-requests": "tooManyRequests",
  "auth/network-request-failed": "network",
  "auth/internal-error": "internal",
  // Usually a sign-in error, but a malformed credential can raise it here too.
  "auth/invalid-credential": "invalidCredential",
};

export const registerErrorKey = (error) =>
  `register.errors.${KEYS[error?.code || error?.errorCode] || "generic"}`;

export default registerErrorKey;
